import { Adapter as r } from "../../../../../adapter.js";
import { LoyaltyProgrammeSettingsModel as m } from "./loyaltyProgrammeSettings.model.js";
class p extends r {
  adapt(e) {
    return new m({
      programmeType: e.programme_type,
      currencyName: e.currency_name
    });
  }
  serialize(e) {
  }
}
export {
  p as LoyaltyProgrammeSettingsAdapter
};
//# sourceMappingURL=loyaltyProgrammeSettings.adapter.js.map
